import type { SelectHTMLAttributes } from 'react';
import { ChevronDownIcon } from '../icons/Icons';

interface SelectOption {
  value: string | number;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: SelectOption[];
  wrapClassName?: string;
}

export function Select({ options, className = '', wrapClassName = '', ...props }: SelectProps) {
  return (
    <span className={`select-wrap ${wrapClassName}`.trim()}>
      <select className={`select ${className}`.trim()} {...props}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDownIcon size={14} className="select-wrap__chevron" />
    </span>
  );
}
